<div>
  <form clrForm>
    <clr-select-container>
      <label>Projection</label>
      <select clrSelect id="useprojectioninput_{{widgetQuery.Id}}" name="useprojectioninput_{{widgetQuery.Id}}"
        [(ngModel)]="widgetQuery.UseProjectionInputParameter">
        <option [ngValue]="true"> Input </option>
        <option [ngValue]="false"> Projection </option>
      </select>

      <select clrSelect style="margin-left: 1em;" *ngIf="!widgetQuery.UseProjectionInputParameter"
        name="projection_{{widgetQuery.Id}}" [(ngModel)]="projection"
        (ngModelChange)="selectedProjectionChange($event)">
        <option *ngFor="let proj of projections" [ngValue]="proj">{{proj.name| xproj_pretty}}</option>
      </select>

      <select clrSelect style="margin-left: 1em;" *ngIf="widgetQuery.UseProjectionInputParameter" class="clr-select"
        name="UseProjectionInputParameter_{{widgetQuery.Id}}" [(ngModel)]="widgetQuery.ProjectionInputParameterId">
        <option *ngFor="let input of inputParameters | xproj_filterinputparameters : [OutputDataType.Projection]"
          [ngValue]="input.id">
          {{input.id}}</option>
      </select>
    </clr-select-container>

    <clr-select-container>
      <label>Input / Group</label>
      <select clrSelect id="usegroupinput_{{widgetQuery.Id}}" name="usegroupinput_{{widgetQuery.Id}}"
        [(ngModel)]="widgetQuery.GroupSelectionType">
        <option [ngValue]="GroupSelectionTypes.GROUP"> Group </option>
        <option [ngValue]="GroupSelectionTypes.GROUP_INPUT"> Input group </option>
        <option [ngValue]="GroupSelectionTypes.GROUP_INPUT_PARAMETERS"> Input parameters </option>
      </select>

      <select clrSelect *ngIf="widgetQuery.GroupSelectionType == GroupSelectionTypes.GROUP_INPUT" class="clr-select"
        name="UseProjectionInputParameter_{{widgetQuery.Id}}" [(ngModel)]="widgetQuery.GroupInputParameterId">
        <option *ngFor="let input of inputParameters | xproj_filterinputparameters : [OutputDataType.Group]"
          [ngValue]="input.id">
          {{input.id}}</option>
      </select>
    </clr-select-container>

    <xproj-group-selection #groupSelect *ngIf="widgetQuery.GroupSelectionType == GroupSelectionTypes.GROUP"
      [projection]="projection" [selected]="widgetQuery.Query?.targetgroup"
      (groupSelected)="selectedProjectionGroupChange($event)">
    </xproj-group-selection>

    <clr-combobox-container *ngIf="widgetQuery.GroupSelectionType == GroupSelectionTypes.GROUP_INPUT_PARAMETERS">
      <label>Group input selections</label>
      <clr-combobox [(ngModel)]="widgetQuery.GroupInputParameterIds" name="multiSelect_{{widgetQuery.Id}}"
        clrMulti="true" required>
        <ng-container *clrOptionSelected="let selected">
          {{selected}}
        </ng-container>
        <clr-options>
          <clr-option
            *clrOptionItems="let input of inputParameters | xproj_filterinputparameters : [OutputDataType.String, OutputDataType.Number];  field:'id'"
            [clrValue]="input.id">
            {{input.id}}
          </clr-option>
        </clr-options>
      </clr-combobox>
    </clr-combobox-container>
  </form>

  <form clrForm>
    <clr-select-container>
      <label>Time filter column</label>
      <select clrSelect id="timefiltercolumn_{{widgetQuery.Id}}" name="timefiltercolumn_{{widgetQuery.Id}}"
        [(ngModel)]="widgetQuery.timestampColumnName">
        <option *ngFor="let col of columns | xproj_filtertimestampcolumns" [ngValue]="col.columnname">
          {{col.columnname}}</option>
      </select>
    </clr-select-container>

    <clr-select-container>
      <label>Default sorting column</label>
      <select clrSelect id="sortingcolumn" name="sortingcolumn" [(ngModel)]="widgetQuery.defaultSortColumnName">
        <option [ngValue]=""> </option>
        <option *ngFor="let col of widgetQuery.DataConfigs" [ngValue]="col.ColumnName">
          {{col.ColumnName}}</option>
      </select>
    </clr-select-container>

    <clr-select-container>
      <label>Default sorting order</label>

      <select clrSelect id="sortingorder" name="sortingorder" [(ngModel)]="widgetQuery.defaultSortDescending">
        <option [ngValue]="false"> Ascending </option>
        <option [ngValue]="true"> Descending </option>
      </select>
    </clr-select-container>

    <clr-datagrid [(clrDgSingleSelected)]="selectedDataConfig">
      <clr-dg-column>Label</clr-dg-column>
      <clr-dg-column>Column</clr-dg-column>
      <clr-dg-column>Aggregation</clr-dg-column>
      <clr-dg-column>Unit</clr-dg-column>
      <clr-dg-column>Move</clr-dg-column>

      <clr-dg-row *ngFor="let dataConfig of widgetQuery.DataConfigs; let i = index" [clrDgItem]="dataConfig">
        <clr-dg-cell>
          <input class="clr-input" placeholder="" name="label_data{{i}}_{{widgetQuery.Id}}"
            [(ngModel)]="dataConfig.Label" />
        </clr-dg-cell>
        <clr-dg-cell>
          <div class="clr-select-wrapper">
            <select class="clr-select" name="tselectdata{{i}}_{{widgetQuery.Id}}"
              id="tselectcolumn_data_{{i}}_{{widgetQuery.Id}}" [(ngModel)]="dataConfig.ColumnName"
              (ngModelChange)="onDataColumnSelect($event, i)">
              <option *ngFor="let col of columns" [ngValue]="col.columnname">
                {{col.columnname}}</option>
              <option *ngFor="let col of preQueryColumnConfigs" [ngValue]="col.columnname">
                {{col.columnname}}</option>
              <option *ngFor="let col of widgetQuery.Query.scriptedcolumnspostaggregation"
                [ngValue]="'script:' + col.columnoutname">
                script:{{col.columnoutname}}</option>
            </select>
          </div>
        </clr-dg-cell>
        <clr-dg-cell>
          <div class="clr-select-wrapper">
            <input class="clr-checkbox" type="checkbox" placeholder="" name="AggregationInput{{i}}_{{widgetQuery.Id}}"
              [(ngModel)]="dataConfig.UseAggregationInputParameter" />
            <select *ngIf="!dataConfig.UseAggregationInputParameter" class="clr-select" style="width:13em;"
              name="dataConfigagg{{i}}_{{widgetQuery.Id}}" [(ngModel)]="dataConfig.Transform">
              <option [ngValue]="Aggregation.NONE"> None </option>
              <option [ngValue]="Aggregation.COUNT"> Count </option>
              <option [ngValue]="Aggregation.DISTINCT_COUNT"> Distinct Count </option>

              <option [ngValue]="Aggregation.SUM"> Sum </option>

              <option [ngValue]="Aggregation.MAX"> Max </option>
              <option [ngValue]="Aggregation.MIN"> Min </option>

              <option [ngValue]="Aggregation.FIRST"> First </option>
              <option [ngValue]="Aggregation.LAST"> Last </option>

              <option [ngValue]="Aggregation.FORWARD_DIFF"> Forward diff </option>

              <option [ngValue]="Aggregation.MEAN_ARITHMETIC"> Mean - arithmetic </option>
              <option [ngValue]="Aggregation.MEAN_GEOMETRIC"> Mean - geometric </option>
              <option [ngValue]="Aggregation.MEAN_HARMONIC"> Mean - harmonic </option>

              <option [ngValue]="Aggregation.MEDIAN"> Median </option>

              <option [ngValue]="Aggregation.SD_SAMPLED_UNCORRECTED"> Standard deviation - uncorrected </option>
              <option [ngValue]="Aggregation.SD_SAMPLED_CORRECTED"> Standard deviation - corrected </option>
              <option [ngValue]="Aggregation.SD_SAMPLED_UNBIASED_APPROX_ND"> Standard deviation - unbiased approx
              </option>

              <option [ngValue]="Aggregation.MAD_ORIGO_MEAN_ARITHMETIC"> Mean absolute deviation - around
                arithmetic mean </option>
              <option [ngValue]="Aggregation.MAD_ORIGO_MEAN_GEOMETRIC"> Mean absolute deviation - around geometric
                mean </option>
              <option [ngValue]="Aggregation.MAD_ORIGO_MEAN_HARMONIC"> Mean absolute deviation - around harmonic
                mean </option>
              <option [ngValue]="Aggregation.MAD_ORIGO_MEDIAN"> Mean absolute deviation - around median </option>
            </select>
            <select *ngIf="dataConfig.UseAggregationInputParameter" class="clr-select" style="width:13em;"
              name="inputparam_{{widgetQuery.Id}}" [(ngModel)]="dataConfig.AggregationInputParameterId">
              <option *ngFor="let input of inputParameters | xproj_filterinputparameters : [OutputDataType.Aggregation]"
                [ngValue]="input.id">
                {{input.id}}</option>
            </select>
          </div>
        </clr-dg-cell>

        <clr-dg-cell>
          <div class="clr-select-wrapper">
            <input class="clr-checkbox" type="checkbox" placeholder="" name="UnitInput_{{widgetQuery.Id}}{{i}}"
              [(ngModel)]="dataConfig.UseUnitInputParameter" />

            <input *ngIf="!dataConfig.UseUnitInputParameter" class="clr-input" placeholder=""
              name="unit_{{widgetQuery.Id}}{{i}}" [(ngModel)]="dataConfig.Unit" />

            <select *ngIf="dataConfig.UseUnitInputParameter" class="clr-select" style="width:13em;"
              name="unitinputparam_{{widgetQuery.Id}}{{i}}" [(ngModel)]="dataConfig.UnitInputParameterId">
              <option *ngFor="let input of inputParameters | xproj_filterinputparameters : [OutputDataType.String]"
                [ngValue]="input.id">
                {{input.id}}</option>
            </select>
          </div>
        </clr-dg-cell>

        <clr-dg-cell>
          <clr-icon (click)="moveColumnUp(i);" shape="circle-arrow" [style.cursor]="'pointer'"></clr-icon>
          <clr-icon (click)="moveColumnDown(i);" shape="circle-arrow" [style.cursor]="'pointer'"
            style="margin-left: 1em; transform: rotate(180deg);"></clr-icon>
        </clr-dg-cell>

      </clr-dg-row>
    </clr-datagrid>

    <button type="button" class="btn btn-link" (click)="addColumn()">
      <clr-icon shape="plus-circle"></clr-icon>
      Add column
    </button>
    <button *ngIf="selectedDataConfig" type="button" class="btn btn-link" (click)="removeSelectedColumn()">
      <clr-icon shape="minus-circle"></clr-icon>
      Remove selected column
    </button>

    <div *ngIf="selectedDataConfig" style="max-width: 600px;">
      <div class="card">
        <div class="card-header">
          Editing label
        </div>

        <div class="card-block">
          <div class="card-title">
            {{selectedDataConfig.Label}}
          </div>

          <clr-input-container>
            <label>Font Family Label</label>
            <input clrInput type="text" [(ngModel)]="selectedDataConfig.FontFamilyLabel"
              name="fontfamilylabel_{{widgetQuery.Id}}" size="35" />
          </clr-input-container>
          <clr-input-container>
            <label>Font Family Value</label>
            <input clrInput type="text" [(ngModel)]="selectedDataConfig.FontFamilyValue"
              name="fontfamilyvalue_{{widgetQuery.Id}}" size="35" />
          </clr-input-container>


          <clr-input-container>
            <label>Font Size Label</label>
            <input clrInput type="text" [(ngModel)]="selectedDataConfig.FontSizeLabel"
              name="fontsizelabel_{{widgetQuery.Id}}" size="35" />
          </clr-input-container>
          <clr-input-container>
            <label>Font Size Value</label>
            <input clrInput type="text" [(ngModel)]="selectedDataConfig.FontSizeValue"
              name="fontsizevalue_{{widgetQuery.Id}}" size="35" />
          </clr-input-container>

          <clr-input-container>
            <label>Margin</label>
            <input clrInput type="text" [(ngModel)]="selectedDataConfig.Margin" name="margin_{{widgetQuery.Id}}"
              size="35" />
          </clr-input-container>

          <clr-select-container>
            <label>Align label</label>
            <select clrSelect id="alignlabel{{widgetQuery.Id}}" name="alignlabel_{{widgetQuery.Id}}"
              [(ngModel)]="selectedDataConfig.AlignLabel">
              <option [ngValue]="'left'"> Left </option>
              <option [ngValue]="'right'"> Right </option>
              <option [ngValue]="'center'"> Center </option>
            </select>
          </clr-select-container>

          <clr-select-container>
            <label>Align value</label>
            <select clrSelect id="alignvalue{{widgetQuery.Id}}" name="alignvalue_{{widgetQuery.Id}}"
              [(ngModel)]="selectedDataConfig.AlignValue">
              <option [ngValue]="'left'"> Left </option>
              <option [ngValue]="'right'"> Right </option>
              <option [ngValue]="'center'"> Center </option>
            </select>
          </clr-select-container>


          <clr-input-container>
            <label>Date format (example: fullDate, keyboardDateTime)</label>
            <input clrInput type="text" [(ngModel)]="selectedDataConfig.DateFormatting"
              name="dateformatting_{{widgetQuery.Id}}" size="35" />
          </clr-input-container>


          <clr-checkbox-container>
            <clr-checkbox-wrapper>
              <input type="checkbox" clrCheckbox name="hidden_{{widgetQuery.Id}}"
                [(ngModel)]="selectedDataConfig.Hidden" />
              <label>Hidden label</label>
            </clr-checkbox-wrapper>
          </clr-checkbox-container>

          <clr-select-container>
            <label>Color property</label>
            <select clrSelect id="colorproperty_{{widgetQuery.Id}}" name="colorproperty_{{widgetQuery.Id}}"
              [(ngModel)]="selectedDataConfig.ColorProperty">
              <option [ngValue]="ColorProperty.TEXT"> Text </option>
              <option [ngValue]="ColorProperty.TEXT_BACKGROUND"> Text background </option>
              <option [ngValue]="ColorProperty.WIDGET_BACKGROUND"> Widget background </option>
            </select>
          </clr-select-container>
          <h5>Color thresholds</h5>
          <clr-datagrid [(clrDgSingleSelected)]="selectedThreshold">
            <clr-dg-column>Value</clr-dg-column>
            <clr-dg-column>Color</clr-dg-column>
            <!-- <clr-dg-column>Move</clr-dg-column> -->

            <clr-dg-row *ngFor="let colorthreshold of selectedDataConfig.ColorThresholds; let i = index"
              [clrDgItem]="colorthreshold">
              <clr-dg-cell>
                <input class="clr-input" type="number" placeholder="0"
                  name="colorthreshold_value{{i}}_{{widgetQuery.Id}}" [(ngModel)]="colorthreshold.Value" />
              </clr-dg-cell>
              <clr-dg-cell>
                <input class="clr-input" type="color" placeholder="" name="colorthreshold_color{{i}}_{{widgetQuery.Id}}"
                  [(ngModel)]="colorthreshold.Color" />
              </clr-dg-cell>
              <!-- <clr-dg-cell>
                <clr-icon (click)="moveThresholdUp(i);" shape="circle-arrow" [style.cursor]="'pointer'"></clr-icon>
                <clr-icon (click)="moveThresholdDown(i);" shape="circle-arrow" [style.cursor]="'pointer'"
                  style="margin-left: 1em; transform: rotate(180deg);"></clr-icon>
              </clr-dg-cell> -->
            </clr-dg-row>
          </clr-datagrid>
          <button type="button" class="btn btn-link" (click)="addThreshold()">
            <clr-icon shape="plus-circle"></clr-icon>
            Add threshold
          </button>
          <button *ngIf="selectedDataConfig" type="button" class="btn btn-link" (click)="removeSelectedThreshold()">
            <clr-icon shape="minus-circle"></clr-icon>
            Remove selected threshold
          </button>

        </div>
      </div>
    </div>
  </form>

  <h5>Filters</h5>
  <xproj-projection-filter #projectionFilter id="projectionFilter_{{widgetQuery.Id}}"
    [projectionid]="projection?.projectionid" [columnDescriptions]="columns" [group]="selectedGroup"
    [datafilters]="widgetQuery.DataFilters" [filterLogicalGroupType]="widgetQuery.FilterLogicalGroupType"
    [inputParameters]="inputParameters" [widgets]="widgets">
  </xproj-projection-filter>

  <br />

  <clr-accordion>
    <clr-accordion-panel *ngFor="let scriptedcolumn of widgetQuery.Query.scriptedcolumnspostaggregation; index as i">
      <clr-accordion-title>ScriptedColumn {{i+1}}</clr-accordion-title>
      <clr-accordion-content>
        <xproj-edit-lua-query-column [luaQueryColumn]="scriptedcolumn"
          (onQueryColumnRemoved)="onLuaQueryColumnRemoved($event)"></xproj-edit-lua-query-column>
      </clr-accordion-content>
    </clr-accordion-panel>
  </clr-accordion>
  <button type="button" class="btn btn-link" (click)="addScriptedColumnsPostAggregation();">
    <clr-icon shape="plus-circle"></clr-icon>
    Add scripted column
  </button>

  <br />
  <br />
  <button class="btn btn-danger-outline" (click)="removeQuery()">Remove query</button>
</div>
